<template>
  <div class="situation">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>教师考核</b>
      <div class="del_btn" @click="handleDel" v-if="list.length > 0">
        删除成绩
      </div>
      <div class="download_btn" @click="handleDownload">
        下载模板 <i class="el-icon-arrow-right"></i>
      </div>
      <el-upload
        class="import_btn"
        action="#"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleimport"
        >导入数据 <i class="el-icon-arrow-right"></i
      ></el-upload>
    </div>
    <div class="main">
      <div class="student_list">
        <div class="list_title">
          <span>学号</span>
          <span>姓名</span>
          <span>性别</span>
          <span>所属团队</span>
          <span>岗位</span>
          <span>成绩</span>
        </div>
        <div class="list_main">
          <div class="row" v-for="item in list" :key="item.userId">
            <span>{{ item.sno }}</span>
            <span>{{ item.nickName }}</span>
            <span>{{ formatSex(item.sex) }}</span>
            <span>{{ item.teamName }}</span>
            <span>{{ item.postName }}</span>
            <span>{{ item.score }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userTeacherScoreList,
  importTeacherScoreTemplate,
  delTeacherScoreList,
} from "@/api/evaluation";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      userTeacherScoreList(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleDownload() {
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/class/teacher/score/${this.$route.query.id}/template`,
        "_blank"
      );
    },
    handleimport(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      this.$loading.show();
      importTeacherScoreTemplate(this.$route.query.id, formData).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("导入成功！");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatSex(string) {
      if (string == "MAN") return "男";
      else if (string == "WOMAN") return "女";
      else return "未知";
    },
    handleDel() {
      this.$confirm(`确定要删除成绩吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delTeacherScoreList(this.$route.query.id).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.situation {
  height: 748px;
  background-image: url("../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .del_btn,
    .download_btn,
    .import_btn {
      position: absolute;
      top: 62px;
      right: 0;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.download_btn {
        right: 130px;
      }
      &.del_btn {
        left: 0;
      }
    }
  }
  .main {
    margin: 20px 2px 0;
    .student_list {
      .list_title {
        padding: 0 32px;
        height: 40px;
        line-height: 40px;
        color: #1de0fe;
        // text-align: left;
        background-color: rgba(82, 255, 255, 0.2);
        span {
          display: inline-block;
          text-align: center;
          &:first-child {
            width: 120px;
          }
          &:nth-child(2) {
            width: 140px;
          }
          &:nth-child(3) {
            width: 60px;
          }
          &:nth-child(4) {
            width: 200px;
          }
          &:nth-child(5) {
            width: 250px;
          }
          &:nth-child(6) {
            width: 200px;
          }
        }
      }
      .list_main {
        padding: 0 30px 0 32px;
        height: calc(748px - 40px - 48px - 20px - 105px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-thumb {
          box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          background-color: #1ae0fe;
        }
        .row {
          padding: 15px 0 6px;
          line-height: 1;
          color: #feffff;
          //   text-align: left;
          border-bottom: solid 1px transparent;
          border-image: linear-gradient(to right, #1de0fe, transparent) 1 10;
          span {
            display: inline-block;
            text-align: center;
            &:first-child {
              width: 120px;
            }
            &:nth-child(2) {
              width: 140px;
            }
            &:nth-child(3) {
              width: 60px;
            }
            &:nth-child(4) {
              width: 200px;
            }
            &:nth-child(5) {
              width: 250px;
            }
            &:nth-child(6) {
              width: 200px;
            }
          }
        }
      }
    }
  }
}
</style>